import { Link } from "react-router-dom";
import CoursePill from "../dashboard/recommendation-section/pills";
import { BeginnerIcon, Sarah1 } from "../../images";
import { renderValidUrl } from "../../utils/constants";
import Button from "../button";
import { Calendar, User } from "lucide-react";

const SimilarProjectCard = ({ project }) => {
  if (!project) return null;

  const category =
    project.pill?.[0]?.pill1 || project.category?.name || "Design";
  const title = project.groupName || project.title || "Project Title";
  const description = project.description || "";
  const thumbnail = project.thumbnail?.url
    ? renderValidUrl(project.thumbnail.url)
    : Sarah1;
  const duration = project.duration || "7 Weeks";
  const level = project.level || "Beginner";
  const role = project.pill?.[0]?.pill2 || project.category?.name || "Designer";

  return (
    <>
      <div className="w-full h-full flex flex-col flex-1 p-[12px] border-box bg-[#FFFFFF] rounded-[4px]">
        <div className="w-full aspect-video flex-shrink-0">
          <img
            src={thumbnail}
            alt={title}
            className="w-full h-[228px] object-cover rounded-[4px]"
          />
        </div>

        <div className="mt-[12px] flex-grow">
          <div className="flex gap-2 items-center">
            <CoursePill course={category} />
            {project.pill?.[0]?.pill2 && (
              <>
                <span className="w-[4px] h-[4px] rounded-full bg-[#000000]"></span>
                <CoursePill course={project.pill[0].pill2} />
              </>
            )}
          </div>

          <div className="mt-2 flex justify-between items-center">
            <p className="text-[16px] leading-[24px] font-bold ">{title}</p>
          </div>
          <p
            className="mt-[12px] text-[12px] leading-[20px] text-[#626262]"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {description}
          </p>
        </div>
        <div className="flex flex-col gap-3 text-[12px] text-gray-600 mt-2 md:flex-row md:items-center md:gap-4">
          <div className="flex items-center gap-1">
            <Calendar className="w-6 h-6 text-primaryYellow" />
            {duration}
          </div>
          <div className="flex items-center gap-1">
            <img src={BeginnerIcon} alt="Level" className="w-[24px] h-[24px]" />{" "}
            {level}
          </div>
          <div className="flex items-center gap-1">
            <User className="w-6 h-6 text-primaryYellow" />
            {role}
          </div>
        </div>

        <div className="mt-auto block pt-4">
          <Link
            to={`/project-details/${project.id}`}
            className="block w-full mt-4"
            onClick={() => window.scrollTo(0, 0)}
          >
            <Button variant="secondary" size={"full"}>
              View Details
            </Button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default SimilarProjectCard;
